import AppointmentRate from "./AppointmentRate";
export default AppointmentRate;